import { ComponentMap } from "@sdk/lib/types/module-config";
import {
  AUDIO,
  CHECKBOX,
  CONTAINER,
  FREE_TEXT,
  HTML,
  IMAGE,
  PDF,
  RADIO,
  SELECT,
  SLIDER,
  SMART_CHECKBOX,
  SMART_RADIO,
  TEXT,
  VIDEO,
} from "@sdk/lib/values/blocks";
import { UpliftUserTextBlockComponent } from "@uplift-sdk/lib/uplift-user-text-block-new/uplift-user-text-block/uplift-user-text-block.component";
import { UpliftUserFreeTextBlockComponent } from "@uplift-sdk/lib/uplift-user-free-text-block-new/uplift-user-free-text-block/uplift-user-free-text-block.component";
import { UpliftUserAudioBlockComponent } from "@uplift-sdk/lib/uplift-user-audio-block-new/uplift-user-audio-block/uplift-user-audio-block.component";
import { UpliftUserHtmlBlockComponent } from "@uplift-sdk/lib/uplift-user-html-block-new/uplift-user-html-block/uplift-user-html-block.component";
import { UpliftUserImageBlockComponent } from "@uplift-sdk/lib/uplift-user-image-block-new/uplift-user-image-block/uplift-user-image-block.component";
import { UpliftUserCheckBoxBlockComponent } from "@uplift-sdk/lib/uplift-user-check-box-block-new/uplift-user-check-box-block/uplift-user-check-box-block.component";
import { UpliftUserRadioBlockComponent } from "@uplift-sdk/lib/uplift-user-radio-block-new/uplift-user-radio-block/uplift-user-radio-block.component";
import { UpliftUserSmartRadioBlockComponent } from "@uplift-sdk/lib/uplift-user-smart-radio-block/uplift-user-smart-radio-block/uplift-user-smart-radio-block.component";
import { UpliftUserSmartCheckBoxBlockComponent } from "@uplift-sdk/lib/uplift-user-smart-check-box-block/uplift-user-smart-check-box-block/uplift-user-smart-check-box-block.component";
import { UpliftUserSelectBlockComponent } from "@uplift-sdk/lib/uplift-user-select-block-new/uplift-user-select-block/uplift-user-select-block.component";
import { UpliftUserContainerBlockComponent } from "@uplift-sdk/lib/uplift-user-container-block/uplift-user-container-block/uplift-user-container-block.component";
import { UpliftUserVideoBlockComponent } from "@uplift-sdk/lib/uplift-user-video-block-new/uplift-user-video-block/uplift-user-video-block.component";
import { UpliftUserPdfBlockComponent } from "@uplift-sdk/lib/uplift-user-pdf-block-new/uplift-user-pdf-block.component";
import { UpliftUserSliderBlockComponent } from "@uplift-sdk/lib/uplift-user-slider-block/uplift-user-slider-block.component";

export const componentMapConfig: ComponentMap = {
  [TEXT]: UpliftUserTextBlockComponent,
  [FREE_TEXT]: UpliftUserFreeTextBlockComponent,
  [AUDIO]: UpliftUserAudioBlockComponent,
  [HTML]: UpliftUserHtmlBlockComponent,
  [IMAGE]: UpliftUserImageBlockComponent,
  [CHECKBOX]: UpliftUserCheckBoxBlockComponent,
  [RADIO]: UpliftUserRadioBlockComponent,
  [SMART_RADIO]: UpliftUserSmartRadioBlockComponent,
  [SMART_CHECKBOX]: UpliftUserSmartCheckBoxBlockComponent,
  [SELECT]: UpliftUserSelectBlockComponent,
  [CONTAINER]: UpliftUserContainerBlockComponent,
  [VIDEO]: UpliftUserVideoBlockComponent,
  [PDF]: UpliftUserPdfBlockComponent,
  [SLIDER]: UpliftUserSliderBlockComponent,
};
